var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "1152px",
        "append-to-body": "",
        "before-close": _vm.closedDialog,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("div", { staticClass: "title-left" }, [_vm._v("详情")]),
      ]),
      _c("div", { staticClass: "info_box" }, [
        _c("div", { staticClass: "title-text mb-16" }, [
          _vm._v(_vm._s(_vm.data.announcementName)),
        ]),
        _c(
          "div",
          { staticClass: "fx-c-center" },
          [
            _c("span", { staticClass: "title-right source-text mr-8" }, [
              _vm._v(_vm._s(_vm.data.pubDate)),
            ]),
            _vm.data.url
              ? _c(
                  "el-link",
                  {
                    attrs: {
                      href: _vm.data.url,
                      type: "primary",
                      target: "_blank",
                    },
                  },
                  [_vm._v("查看原文")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "policy-text" }, [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.data.rawContent) } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }